// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","text":"Topic_text__ODUK9","description":"Topic_description__JA0Jc"};